import { Group, GroupFilterCondition } from "@fairfleet/geotab";

/**
 * The subset of {@link GroupFilterCondition} that is actually sent to the API.
 *
 * The generated Geotab type marks every member as required, but a search only ever
 * carries the members below, so the built conditions are modelled explicitly instead
 * of being widened by inference at every call site.
 */
export type PartialGroupFilterCondition = {
  groupFilterConditions?: PartialGroupFilterCondition[];
  groupId?: string;
  relation?: string;
};

export default function createGroupFilter(
  groups: Group[] | undefined,
  groupFilterCondition: GroupFilterCondition | undefined,
  additionalAttributes: { [key: string]: any },
): { [key: string]: any; groupFilterCondition?: PartialGroupFilterCondition } {
  // An explicit group selection wins — it is what the user picked in the group dropdown.
  if (groups !== undefined && groups.length > 0) {
    return {
      ...additionalAttributes,
      groupFilterCondition:
        groups.length > 1
          ? {
              groupFilterConditions: groups.map(g => ({ groupId: g.id })),
              relation: "OR",
            }
          : { groupId: groups[0].id },
    };
  }

  // Otherwise use the advanced filter as MyGeotab reported it. MyGeotab hands over an empty
  // `groups` array when no simple group is selected, which is exactly when the advanced filter
  // is the only scope there is. It reports `null` (not `undefined`) when there is none, and a
  // `groupFilterCondition: null` in the search would be sent to the API as-is.
  if (groupFilterCondition) {
    return { ...additionalAttributes, groupFilterCondition };
  }

  return { ...additionalAttributes };
}
